export default __webpack_public_path__ + "static/media/zec.0fb4c9af.png";